export default __webpack_public_path__ + "static/media/winner2.05a5eac2.png";